<template>
	<AppLayout>
		<div class="col-12 layout-spacing">
			<div class="widget widget-six">
				<div class="widget-heading">
					<div class="row align-items-center">
						<div class="col d-flex align-items-center">
							<h4 class="me-3 my-0">Lista zamówień z inventora</h4>
							<button @click="addProductionOut" class="btn btn-primary btn-sm me-3"><i class="bi bi-plus-circle me-2"></i>Dodaj pozycję</button>
						</div>
						<div class="col-auto d-flex align-items-center">
							<div class="form-check form-switch form-switch-success d-flex align-items-center">
								<input class="form-check-input" type="checkbox" role="switch" id="showArchivedPrOut" style="height:1.5em; width:3em;" v-model="archivedPrOutShown">
								<label class="form-check-label ms-2 mb-0" for="showArchivedPrOut">Pokaż zarchiwizowane</label>
							</div>
						</div>
					</div>
				</div>
				<div class="widget-content">
					<div class="row">		
						<div class="custom-table col-md-12">
							<div class="row mb-3">
								<div class="col-3">
									<input v-model="searchQuery" class="form-control form-sm" placeholder="Szukaj po nazwie...">
								</div>
								<div class="col-9 text-end">
									<label>Liczba rekordów na stronie: </label>
									<select v-model.number="pageSize" class="form-select form-sm d-inline w-auto ms-2">
										<option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option>
									</select>
								</div>
							</div>
							<div class="table-responsive">
								<table v-if="addingNew" id="production-out-add-table" class="table table-hover">
									<thead>
										<tr>
											<th>Nazwa</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><input v-model="newProductionOut.name" class="form-control"/>
											 <div
        v-if="$page.props.errors.name"
        class="text-danger mt-1"
    >
        {{ $page.props.errors.name }}
    </div>
											
											</td>
											<td>
												<button @click="saveNewProductionOut" class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2 equal-width-btn"></i>Zapisz</button>
												<button @click="cancelProductionOut" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2 equal-width-btn"></i>Anuluj</button>
											</td>
										</tr>
									</tbody>
								</table>
								<table id="production-out-table" class="table table-hover">
									<thead>
										<tr>
											<th>#</th>
											<th @click="changeSort('name')" style="cursor:pointer;">Nazwa</th>
											<th @click="changeSort('created_at')" style="cursor:pointer;">Utworzono</th>
											<th>Akcje</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(productionout, pid) in paginatedProductionOut" :key="productionout.id">
											<td>{{ pid + 1 + (currentPage - 1) * pageSize }}</td>
											<td>
											<input v-if="editingId === productionout.id" v-model="productionout.name" class="form-control"/>
											<span v-else @click="selectProductionOut(productionout)" style="cursor:pointer; color:blue;">{{ productionout.name }}</span>
											</td>
											<td>{{ formatDate(productionout.created_at) }}</td>
											<td>
												<a :href="route('inventor.parser.show', {id: productionout.id })" class="btn btn-info btn-sm me-2 mb-2 equal-width-btn"><i class="bi bi-url"></i> &nbsp;Przejdź</a>
												<button v-if="editingId === productionout.id" @click="updateProductionOut(productionout)" class="btn btn-sm btn-success mb-2 me-2">Zapisz</button>
												<button v-else @click="editProductionOut(productionout.id)" class="btn btn-sm btn-outline-info me-2 mb-2 "><i class="bi bi-pencil equal-width-btn"></i>Edytuj</button>
												<button  @click="deleteProductionOut(productionout.id)" class="btn btn-sm btn-danger mb-2"><i class="bi bi-trash me-2 equal-width-btn"></i>Usuń</button>
											</td>				  
										</tr>
									</tbody>
								</table>

							</div>
							<nav aria-label="Page navigation">
								<ul class="pagination justify-content-center mt-3">
									<li class="page-item" :class="{ disabled: currentPage === 1 }">
									<a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Poprzednia</a>
									</li>
								
									<li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: page === currentPage }">
									<a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
									</li>
								
									<li class="page-item" :class="{ disabled: currentPage === totalPages }">
									<a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Następna</a>
									</li>
								</ul>
							</nav>
						</div>
						
					</div>	  
				</div>
			</div>
		</div>
	</AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";


export default {
  components: { AppLayout},
  props: {
    production_out: Array, 
	
  },
  data() {
    return {
      editingId: null,
      addingNew: false,
	  archivedPrOutShown: false,
	  selectedProductionOut: null,
	  editedValue: null,
	  editedField: null,
      newProductionOut: this.getEmptyForm(),
	  currentPage: 1,
	  searchQuery: '',
	  pageSizeOptions: [10, 20, 50, 100],
	  pageSize: 10,
	  sortColumn: 'name', 
	  sortDirection: 'desc', 
    };
  },
  watch: {
  pageSize(newSize, oldSize) {
    this.adjustCurrentPage();
  },
  filteredProductionOut() {
    this.adjustCurrentPage();
  }
},
  computed: {
  filteredProductionOut() {
    let data = this.archivedPrOutShown
      ? this.production_out
      : this.production_out.filter(po => !po.archived);

    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      data = data.filter(po => po.name.toLowerCase().includes(query));
    }

    return data;
  },
 sortedProductionOut() {
    let data = [...this.filteredProductionOut];

    if (!this.sortColumn) return data;

    return data.sort((a, b) => {
      let valA = a[this.sortColumn];
      let valB = b[this.sortColumn];
      valA = String(valA).toLowerCase();
      valB = String(valB).toLowerCase();
      if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  },

  paginatedProductionOut() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.sortedProductionOut.slice(start, end);
  },

  totalPages() {
    return Math.ceil(this.sortedProductionOut.length / this.pageSize);
  }

  },
  methods: {
  
   adjustCurrentPage() {
    const totalPages = Math.ceil(this.sortedProductionOut.length / this.pageSize);
    if (this.currentPage > totalPages) {
      this.currentPage = totalPages || 1; // jeśli totalPages = 0, ustawiamy na 1
    }
  },
  
  changePage(page) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
  },
	changeSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
	},

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
	
    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },
	
    addProductionOut() {
      this.addingNew = true;
      this.newProductionOut = this.getEmptyForm();
    },
	
    cancelProductionOut() {
      this.addingNew = false;
      this.newProductionOut = this.getEmptyForm();
    },
	
    editProductionOut(id) {
      this.editingId = id;
    },
	
    updateProductionOut(productionout) {
      this.$inertia.put(route('inventor.parser.update', productionout.id), productionout, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },
	
    saveNewProductionOut() {
      this.$inertia.post(route('inventor.parser.store'), this.newProductionOut, {
        onSuccess: () => {
          this.addingNew = false;
          this.newProductionOut = this.getEmptyForm();
        }
      });
    },
	
    formatMoney(value) {
      return new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
	
    deleteProductionOut(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie  wpisu',
        html: 'Czy na pewno chcesz usunąć wybraną pozycję i wszystkie jej dane?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
		position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('inventor.parser.destroy', id));
        }
      })
    }
  }
}
</script>
<style scoped>
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
#production-out-table th {
  font-size: 18px;
  font-weight: 600;
}
#production-out-table td {
  font-size: 16px;
}

</style>